import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-claim',
  templateUrl: './claims.component.html',
  styleUrls: ['./claims.component.css']
})
export class ClaimsComponent implements OnInit {

  title="Authorize"

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/ultilities/claims/claims/claims.component.ts